import React, { Fragment, PureComponent } from 'react'
// import { observer } from 'mobx-react'
import Button from 'react-bootstrap/lib/Button'
import i18n from 'i18next'
import { DragDropContext } from 'react-beautiful-dnd'
import PriorityWell from './formElements/PriorityWell'
import PriorityAnswer from './formElements/PriorityAnswer'
import { getPrintPreview } from './utils'
import PriorityOptionList from './formElements/PriorityOptionList'

// @observer
class PriorityClick extends PureComponent {
    constructor(props) {
        super(props)
        const { question, store } = props
        const { form_data } = store
        const responses = form_data.has(question.id) ? form_data.get(question.id).data : {}
        const priorities = new Array(question.optionSet.options.filter(o => o.willDisplay !== false).length)
        Object.keys(responses).forEach((key) => {
            priorities[(responses[key] - 1)] = key
        })
        this.maxRankedItems = question.settings.frontend.hasOwnProperty('maxRankedItems') && question.settings.frontend.maxRankedItems > 0 ? question.settings.frontend.maxRankedItems : question.optionSet.options.filter(o => o.willDisplay !== false).length
        this.state = {
            priorities,
        }
    }

    handleClear = (e) => {
        e.preventDefault()
        const { question, store } = this.props
        store.priorityClickCounters[question.id] = 0
        question.settings.frontend.maxSelected = 0
        store.resetQuestionResponse(question)
        this.setState({
            priorities: new Array(question.optionSet.options.filter(o => o.willDisplay !== false).length),
        })
    }

    componentDidMount() {
        const { question, store } = this.props
        const { form_data, priorityClickCounters } = store
        if (Object.hasOwnProperty.call(question.settings.frontend, 'maxSelected') && this.clickNum < question.settings.frontend.maxSelected) {
            store.priorityClickCounters[question.id] = question.maxSelected
        }
    }

    removeResponse = (optionId) => {
        const { question, store } = this.props
        const questionId = question.id
        const { form_data, priorityClickCounters } = store

        const { data } = form_data.get(questionId)
        const priority = data[optionId]

        Reflect.deleteProperty(data, optionId)

        Object.keys(data).forEach((key) => {
            const value = data[key]
            if (value > priority) {
                data[key] = (value - 1)
            }
        })

        priorityClickCounters[question.id] -= 1
        question.maxSelected = priorityClickCounters[question.id]
        const priorities = [...this.state.priorities]
        priorities.splice((priority - 1), 1)
        this.setState({
            priorities,
        })
    }

    reorderOptionsResponse = (priorities) => {
        const { question, store } = this.props
        store.resetQuestionResponse(question)
        const valueObj = {}
        priorities.forEach((opt, index) => {
            valueObj[opt] = index + 1
        })
        store.addFormResponse(question, valueObj)
    }

    handleClick = (option, index = false) => {
        const { question, store } = this.props
        const { form_data, priorityClickCounters } = store
        const questionId = question.id
        const set = question.optionSet
        const { options } = set
        const maxRankedItems = question.settings.frontend.hasOwnProperty('maxRankedItems') && question.settings.frontend.maxRankedItems > 0 ? question.settings.frontend.maxRankedItems : options.filter(o => o.willDisplay !== false).length
        const alreadyExists = !!(form_data.has(questionId) && form_data.get(questionId).data.hasOwnProperty(option.id))
        console.log(`alreadyExists: ${alreadyExists}`)
        console.log(`clicknum: ${priorityClickCounters[question.id]}`)
        if (!alreadyExists && priorityClickCounters[question.id] < maxRankedItems && option) {
            priorityClickCounters[question.id] += 1
            question.maxSelected = priorityClickCounters[question.id]
            const valueObj = new Object()
            valueObj[option.id] = priorityClickCounters[question.id]
            const priorities = [...this.state.priorities]
            if (index === false || index === priorities.length) {
                priorities[valueObj[option.id] - 1] = option.id
                store.addFormResponse(question, valueObj)
            } else {
                if (priorities.indexOf(option.id) > -1) {
                    priorities.splice(priorities.indexOf(option.id), 1)
                }
                priorities.splice(index, 0, option.id)
                this.reorderOptionsResponse(priorities.filter(p => p !== undefined))
            }
            console.log('OD setState')
            this.setState({
                priorities,
            })
        }
    }

    // shouldComponentUpdate() {
    //     console.log('OD shouldComponentUpdate')
    //     return false
    // }

    getWells = (options) => {
        const { question, store } = this.props
        const { priorityClickCounters } = store
        const { priorities } = this.state
        const displayMobile = store.displayForMobile()
        console.log('getWells')
        options.sort((a, b) => (priorities.indexOf(a.id) === -1) - (priorities.indexOf(b.id) === -1)
            || +(priorities.indexOf(a.id) > priorities.indexOf(b.id))
            || -(priorities.indexOf(a.id) < priorities.indexOf(b.id)))
        return options.reduce(([optionArr, answerArr], option, index) => {
            const priority = (index + 1)
            const answered = this.state.priorities.includes(option.id)
            const disabled = priorityClickCounters[question.id] >= this.maxRankedItems
            // console.log(priority, answered, optionId)
            optionArr.push(<PriorityWell
                key={option.id}
                option={option}
                question={question}
                answered={answered}
                disabled={!answered && disabled}
                displayMobile={displayMobile}
                store={store}
                handleClick={this.handleClick}
            />)
            if (!displayMobile && index < this.maxRankedItems) {
                answerArr.push(<PriorityAnswer
                    key={`answer_${priority}`}
                    optionId = {this.state.priorities[index]}
                    question={question}
                    store={store}
                    priority={priority}
                    handleClick={this.removeResponse}
                />)
            }
            return [optionArr, answerArr]
        }, [new Array(options.length).fill(null), new Array(options.length).fill(null)])
    }

    onDragEnd = ({ source, destination, draggableId }) => {
        const { question, store } = this.props

        if (!destination) return
        if (destination.droppableId === source.droppableId && source.droppableId === 'droppable_options') return
        if (destination.droppableId === source.droppableId && source.index === destination.index) return
        const option = question.optionSet.options.find(o => o.id === draggableId)

        if (source.droppableId === 'droppable_answers' && destination.droppableId === 'droppable_answers' && source.index !== destination.index) {
            const priorities = [...this.state.priorities]
            priorities.splice(source.index, 1)
            priorities.splice(destination.index, 0, draggableId)
            this.reorderOptionsResponse(priorities.filter(p => p !== undefined))
            this.setState({ priorities })
            return
        }

        if (this.state.priorities.includes(draggableId)) {
            this.removeResponse(draggableId)
        } else {
            this.handleClick(option, destination.index)
        }
    }

    mobileRender = () => {
        const { question, store } = this.props
        const { form_data } = store
        const clearBtn = form_data.has(question.id) && form_data.get(question.id).total > 0 ? <div className='navbutton' onClick={this.handleClear}>{i18n.t('buttons.clearSelection')}</div> : null
        console.log('OD render')
        const [optionWells] = this.getWells(question.optionSet.options.filter(o => o.willDisplay !== false))
        return (
            <Fragment>
                {getPrintPreview(question, store)}
                <div className="question__priority">
                    <div className='answerOptions mobile'>
                        {optionWells}
                    </div>
                    <div className="clearSelection">
                        {clearBtn}
                    </div>
                </div>
            </Fragment>
        )
    }

    desktopRender = () => {
        const { question, store } = this.props
        const { form_data, is_rtl_language } = store
        const clearBtn = form_data.has(question.id) && form_data.get(question.id).total > 0 ? <div className='navbutton' onClick={this.handleClear}>{i18n.t('buttons.clearSelection')}</div> : null
        console.log('OD render')
        const options = question.optionSet.options.filter(o => o.willDisplay !== false)
        const chevron = is_rtl_language ? 'fa-chevron-left' : 'fa-chevron-right'
        return (
            <Fragment>
                {getPrintPreview(question, store)}
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <div className="question__priority">
                        <div className='answerOptions'>
                            <PriorityOptionList
                                options={options}
                                type={'options'}
                                store={store}
                                question={question}
                                priorities={this.state.priorities}
                                handleClick={this.handleClick}
                                setHeight = {height => this.setState({ height })}
                                height={this.state.height}
                            />
                        </div>
                        <div className='separtor'><i className={`far ${chevron}`}/></div>
                        <div className='answerPriority'>
                            <PriorityOptionList
                                options={options}
                                type={'answers'}
                                store={store}
                                question={question}
                                priorities={this.state.priorities}
                                handleClick={this.removeResponse}
                                height={this.state.height}
                            />
                        </div>

                        <div className="clearSelection">
                            {clearBtn}
                        </div>
                    </div>
                </DragDropContext>
            </Fragment>
        )
    }


    render() {
        const { store } = this.props
        const displayMobile = store.displayForMobile()
        return (
            <Fragment>
                {displayMobile ? this.mobileRender() : this.desktopRender() }
            </Fragment>
        )
    }
}

export default PriorityClick
